var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStyleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7748 14.5062C20.9304 13.8236 21.0059 13.1251 20.9998 12.425C20.9623 7.46562 16.8561 3.45312 11.9061 3.49999C9.79141 3.52229 7.75212 4.28856 6.14601 5.66435C4.5399 7.04015 3.46957 8.93758 3.12281 11.0238C2.77604 13.1099 3.175 15.2516 4.24967 17.073C5.32434 18.8944 7.00609 20.2792 8.99985 20.9844C9.339 21.1065 9.70263 21.1451 10.0599 21.0967C10.4171 21.0484 10.7574 20.9145 11.0518 20.7066C11.3463 20.4986 11.5862 20.2227 11.7513 19.9022C11.9163 19.5817 12.0016 19.2261 11.9998 18.8656V18.5C11.9986 18.2042 12.056 17.911 12.1686 17.6375C12.2812 17.3639 12.4469 17.1154 12.6561 16.9062C12.8653 16.6971 13.1138 16.5314 13.3873 16.4187C13.6609 16.3061 13.954 16.2488 14.2498 16.25H18.5811C19.0901 16.2503 19.5841 16.0781 19.9826 15.7613C20.381 15.4446 20.6603 15.0022 20.7748 14.5062V14.5062Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.5625C12.5178 8.5625 12.9375 8.14277 12.9375 7.625C12.9375 7.10723 12.5178 6.6875 12 6.6875C11.4822 6.6875 11.0625 7.10723 11.0625 7.625C11.0625 8.14277 11.4822 8.5625 12 8.5625Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78125 11C8.29902 11 8.71875 10.5803 8.71875 10.0625C8.71875 9.54473 8.29902 9.125 7.78125 9.125C7.26348 9.125 6.84375 9.54473 6.84375 10.0625C6.84375 10.5803 7.26348 11 7.78125 11Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78125 15.875C8.29902 15.875 8.71875 15.4553 8.71875 14.9375C8.71875 14.4197 8.29902 14 7.78125 14C7.26348 14 6.84375 14.4197 6.84375 14.9375C6.84375 15.4553 7.26348 15.875 7.78125 15.875Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2188 11C16.7365 11 17.1562 10.5803 17.1562 10.0625C17.1562 9.54473 16.7365 9.125 16.2188 9.125C15.701 9.125 15.2812 9.54473 15.2812 10.0625C15.2812 10.5803 15.701 11 16.2188 11Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleIcon);
export default __webpack_public_path__ + "static/media/styleIcon.47feb8c97e7beaca02ad87ccb9d12195.svg";
export { ForwardRef as ReactComponent };